import React, { useState, } from "react";
import { useNavigate } from "react-router";
import { Button, Spinner } from "react-bootstrap";
import Cleave from 'cleave.js/react';

import {
    unitLabels,
    addActivityCopy,
  } from "../../services";

export const CopyActivityForm = ({
    activityDetails,
    trails,
    closeModal,
  }) => {
    const [title, setTitle] = useState(activityDetails.title + "_copy");
    const [timeOptGpxFile, setTimeOptGpxFile] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setLoad] = useState(false);
    const [currentTimeOption, setCurrentTimeOpt] = useState("");
    const [expectedTime, setExpectedTime] = useState("");
    const [preferredUnit, setPreferredUnit] = useState(localStorage.getItem('unit'));
  
    const navigate = useNavigate();
  
    const [buttonsState, setButtonsState] = useState({
      btn1: false,
      btn2: false,
      btn3: false,
    });
  
    const btn1ClassList = buttonsState.btn1
      ? "activity__option-btn activity__option-btn_active"
      : "activity__option-btn";
    const btn2ClassList = buttonsState.btn2
      ? "activity__option-btn activity__option-btn_active"
      : "activity__option-btn";
    const btn3ClassList = buttonsState.btn3
      ? "activity__option-btn activity__option-btn_active"
      : "activity__option-btn";
  
    const handleFormSubmission = (e) => {
      e.preventDefault();
      setError(null);
      setLoad(true);
      if (title.length < 3 || title.length > 64) {
        setError(`Activity name must be between 3 and 64 characters`);
        setLoad(false);
        return;
      }
      if (currentTimeOption && currentTimeOption !== "gpx" && !expectedTime) {
        setError(`Enter expected time/pace, or uncheck the box`);
        setLoad(false);
        return;
      }
      if (expectedTime && currentTimeOption !== "gpx") {
        let regex = /^([0-9]+):([0-5][0-9]):([0-5][0-9])$/;
        if (!expectedTime.match(regex)) {
          setLoad(false);
          setError(`Time has to be on hh:mm:ss format`);
          return;
        }
      }
      console.log("ActivityCopy: " + activityDetails);
      addActivityCopy(
        title,
        currentTimeOption,
        expectedTime,
        preferredUnit,
        activityDetails.uuid,
      )
        .then(async (res) => {
          if (!res.ok) {
            const contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
              return res.json().then((newError) => {
                console.log(newError.error);
                setError(newError.error);
                throw new Error(newError.error);
              });
            } else {
              return res.text().then((text) => {
                const parsingError =
                  "We had issues processing the gpx track. Please try again or use another one";
                console.log(parsingError);
                setError(parsingError);
                throw new Error(parsingError);
              });
            }
          } else {
            return await res.json();
          }
        })
        .then((res) => {
          setLoad(false);
          navigate('/plan/activity/' + res.uuid);
          closeModal();
        })
        .catch((error) => {
          setError(error.message);
          setLoad(false);
        });
    };
  
    const handleTitleChange = (e) => {
      setTitle(e.target.value);
    };
  
    const onTrackOptionChange = (e) => {
      /* if (e.target.value) {
        setTimeOptTrack(true);
      } else {
        setTimeOptTrack(false);
      } */
      setExpectedTime(e.target.value);
      try {
        if (e.target[e.target.value].innerText) setTimeOptGpxFile(e.target[e.target.value].innerText);     
      } catch (error) {
        setTimeOptGpxFile("_undefined_");
      }
    };
  
    const handleTimeChange = (e) => {
      setExpectedTime(e.target.value);
    };
    
    const handleUnitChange = (e) => {
      if (localStorage.getItem('unit') === 'mi') {
        setPreferredUnit('km');
        localStorage.setItem('unit','km');
      }
      else {
        setPreferredUnit('mi');
        localStorage.setItem('unit','mi');
      }
    };
  
    const handleErrorCancel = () => {
      setError(false);
    };
  
    const setTimeOptionType = (e) => {
      let txtOpt = document.querySelector(".time__option_txt");
      txtOpt.value = "";
  
      if (currentTimeOption === e.target.value) {
        setExpectedTime("");
        setCurrentTimeOpt("");
      } else if (e.target.value !== undefined) {
        setCurrentTimeOpt(e.target.value);
      }
      // options: pace, time, gpx
    };
  
    //TODO: Doesn't work for gpx option
    const newDescription = () => {
      let sysGenDescription = activityDetails.description;
      let timeOption;
      if (currentTimeOption === "pace") {
        timeOption = timeOption + "\nmy time settings: target pace [" + expectedTime + " " + unitLabels()[0] + "]\n";
      }
      else if (currentTimeOption === "time") {
        timeOption = timeOption + "\nmy time settings: target time [" + expectedTime + "]\n";
      }
      else if (currentTimeOption === "gpx" && expectedTime > 0 && trails.find(x => x.id === parseInt(expectedTime))) {
        timeOption = timeOption + "Used track " + trails.find(x => x.id === parseInt(expectedTime)).title + " as reference to estimate time\n";
      }
      else if (currentTimeOption === "gpx" && timeOptGpxFile && expectedTime.name) {
        timeOption = timeOption + "Used track " + expectedTime.name + " as reference to estimate time\n";
      }
      else {
        timeOption = " ";
      }
      sysGenDescription = sysGenDescription + timeOption;
      return sysGenDescription;
    }
  
    return (
      <>      
        {error && (
          <div className="error-flash-react">
            <div className="error-flash-react-close" onClick={handleErrorCancel}>
              x
            </div>
            {error}
          </div>
        )}
        {/* While isLoading == true, show preloader */}
        {isLoading ? (
          <div className="wrapper">
            <span>Copying activity, please wait...</span>
            <Spinner className="spinner-border text-primary" animation="border" role="status">
            </Spinner>
          </div>
        ) : null}
        <form className="add-activity-modal-form" onSubmit={handleFormSubmission}>
        <h5 className="modal-title add-activity-modal-title">Save a Copy</h5>
          <div className="form-group">
            <label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={handleTitleChange}
                placeholder="Activity name"
              />
            </label>
              <input
                type="hidden"
                className="form-control"
                value={newDescription}
                placeholder="Activity description"
              />
          </div>
          <div className="form-group time-settings-grp">
            <div className="time-settings-title">
              Time Settings (Optional)
            </div>
  
            <div
              className="btn-group time__option__btn-grp"
              role="group"
              aria-label="Basic example"
            >
              <button
                type="button"
                className={btn1ClassList}
                onClick={(e) => {
                  setButtonsState((prev) => {
                    return {
                      btn1: !prev.btn1,
                      btn2: false,
                      btn3: false,
                    };
                  });
                  setTimeOptionType(e);
                }}
                value="time"
              >
                Set target time
              </button>
              <button
                type="button"
                className={btn2ClassList}
                onClick={(e) => {
                  setButtonsState((prev) => {
                    return {
                      btn1: false,
                      btn2: !prev.btn2,
                      btn3: false,
                    };
                  });
                  setTimeOptionType(e);
                }}
                value="pace"
              >
                Set target pace
              </button>
              <button
                type="button"
                className={btn3ClassList}
                onClick={(e) => {
                  setButtonsState((prev) => {
                    return {
                      btn1: false,
                      btn2: false,
                      btn3: !prev.btn3,
                    };
                  });
                  setTimeOptionType(e);
                }}
                value="gpx"
              >
                Use another track
              </button>
            </div>
            <div
              style={{
                display:
                  currentTimeOption === "time" || currentTimeOption === "pace"
                    ? "block"
                    : "none",
              }}
            >
              <div className="activity-opt__select-bar">
                <label>Enter your target {currentTimeOption} below</label>
                <Cleave
                  type="text"
                  placeholder="hh:mm:ss format"
                  options={{delimiter: ':', blocks:[2,2,2], numericOnly:true}}
                  onChange={handleTimeChange}
                  className="form-control time__option_txt"
                />
                <Button 
                  style={{
                    display:
                      currentTimeOption === "pace"
                        ? "block"
                        : "none",
                    }}
                  background="transparent"
                  color="#00427D"
                  margin-top="10px"
                  variant="primary" 
                  size="sm"
                  onClick={handleUnitChange}
                  >
                    {unitLabels()[0]}
                </Button> 
              </div>
            </div>
            {currentTimeOption === "gpx" && (
              <div className="activity-opt__select-bar">
                <label>
                  Not sure of the target time? Use another activity to set one.
                </label>
                <label>
                <select
                  className="form-control-time-file"
                  disabled={timeOptGpxFile ? true : false}
                  onChange={(e) => onTrackOptionChange(e)}
                >
                  <option value="">
                    {"Select or upload the track to use as reference"}
                  </option>
                  {trails.map((trail, idx) => (
                    <option key={idx} value={trail.id}>
                      {trail.title}
                    </option>
                  ))}
                </select>
                </label>
              </div>
            )}
          </div>
          <button
            type="submit"
            className="btn btn-primary btn-primary-create-activity"
          >
            Copy activity
          </button>
        </form>
      </>
  
    );
  };